import React from 'react';
import {Dropdown, DropdownChangeEvent} from 'primereact/dropdown';

interface DropdownOption {
  value: string;
  label: string;
}

interface CenteredDropdownProps {
  id: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: DropdownOption[];
  placeholder: string;
  label: string;
  icon?: string;
  required?: boolean;
}

const CenteredDropdown: React.FC<CenteredDropdownProps> = ({
                                                             id,
                                                             name,
                                                             value,
                                                             onChange,
                                                             options,
                                                             placeholder,
                                                             label,
                                                             icon,
                                                             required = false
                                                           }) => {
  const handleDropdownChange = (e: DropdownChangeEvent) => {
    const syntheticEvent = {
      target: {
        name: name,
        value: e.value || ''
      }
    } as React.ChangeEvent<HTMLSelectElement>;
    onChange(syntheticEvent);
  };

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <div className="relative">
        <Dropdown
          id={id}
          name={name}
          value={value || null}
          options={options}
          onChange={handleDropdownChange}
          optionLabel="label"
          optionValue="value"
          placeholder={placeholder}
          className="w-full px-4 py-3 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-gray-800 focus:border-transparent transition duration-300"
        />
        {icon && <i className={`absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 ${icon}`}/>}
      </div>
    </div>
  );
};

export default CenteredDropdown;

